import React, { useEffect, useState } from "react";
import PageTitle from "../PageTitle";
import PageTitleSecondary from "../PageTitleSecondary";
import ButtonBase from "../components/buttons/ButtonBase";
import ButtonBaseOutline from "../components/buttons/ButtonBaseOutline";
import { Link, useParams } from "react-router-dom";
import HWCardList from "../components/cards/HomeworkCardList";
import BreadcrumbsBase from "../components/buttons/Breadcrumbs";

import { $host } from "../../../http";
import generateBreadcrumbs from "../utils/breadcrumbs";

const SingleTopic = () => {
    const {id: themeId} = useParams()

    const [theme, setTheme] = useState()
    const [breadcrumbs, setBreadcrumbs] = useState([])  


    useEffect(() => {
        (async () => {
            try {
                const {data} = await $host.get(`/api/students/themes/${themeId}`)
                const {homework_id} = data.theme
                
                setTheme({
                    ...data.theme,
                    homework_id: parseInt(homework_id) === 0 ? null : homework_id
                })
                setBreadcrumbs(generateBreadcrumbs(data.breadcrumbs))
            } catch(e) {
                console.error(e)
            }
        })();
    }, [themeId])

    return ( 
        <section className="py-10 pl-6 px-6 w-full">
            <BreadcrumbsBase items={breadcrumbs} />
            {
                theme && (
                    <>
                    <div className="mb-12 pl-6">
                        <div className="flex justify-between items-center pb-8 pt-16">
                            <PageTitle>{theme.title}</PageTitle>
                            <div className="flex gap-2">
                                <Link to="edit">
                                    <ButtonBaseOutline>Редактировать</ButtonBaseOutline>
                                </Link>
                                <Link to={`stream`}>
                                    <ButtonBase>Стрим</ButtonBase>
                                </Link>
                            </div>
                        </div>
                        <div className="text-[18px] text-blue-gray-60 font-medium mb-6">
                            <p>{theme.description}</p>
                        </div>
                    </div>
                    {theme.homework_id && <div>
                        <div className="pl-6 flex gap-1 items-baseline flex-wrap">
                            <PageTitleSecondary>Домашняя работа</PageTitleSecondary>
                            <span className="text-blue-gray/50 font-medium">ID: {theme.homework_id}</span>
                        </div>
                        <div className="mt-8">
                            <HWCardList hwId={theme.homework_id} />
                        </div>
                    </div>}
                    </>
                )
            }
        </section>
    )
}

export default SingleTopic